<template>

    <div class="centered vue-loader" style="height: calc(100vh - 150px)" v-if="loading">
        <vue-loader></vue-loader>
    </div>

    <div class="screen" v-else>
        <div class="eventRequests">
            <div class="event-card" style="background-color: #63c2de">
                All users: {{all_users}}
            </div>
            <div class="event-card" style="background-color: #e83e8c">
                Clients: {{companies}}
            </div>
            <div class="event-card" style="background-color:#ffc107">
                Cites: 5
            </div>
            <div class="event-card" style="background-color: #4dbd74">
                Bus Lines: {{all_buses.length}}
            </div>
            <div class="event-card" style="background-color: #c8ced3">
                Users: {{all_users - companies}}
            </div>
            <div class="event-card" style="background-color: #73818f">
                Parking zones: {{parking_zones}}
            </div>
            <div class="event-card" style="background-color: #17a2b8">
                App store
            </div>
            <div class="event-card" style="background-color: #f86c6b">
                Play store
            </div>
        </div>


        <div class="eventScheduler">
            <el-table
                    :data="users.filter(el => el.email.includes(search.toLowerCase()))"
                    style="width: 100%;overflow: scroll"
                    height="60vh"
            >
                <el-table-column
                        prop="id"
                        label="Id"
                >
                    <template slot-scope="scoope" @click="onClickUser(scoope.row)">
                        {{scoope.$index + 1}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="email"
                        label="Email">
                </el-table-column>
                <el-table-column
                        align="right">
                    <template slot="header">
                        <label>
                            <input
                                    class="no-border-input"
                                    style="padding: 5px; border-radius: 4px"
                                    v-model="search"
                                    size="mini"
                                    placeholder="Type to search"/>
                        </label>
                    </template>
                </el-table-column>
                <el-table-column
                        label="Action">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                type="danger"
                                @click="userToDelete=scope.row">Delete
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <modal cross-btn="true" size-close-icon="md" size="40%" v-if="userToDelete !== null"
               @close="userToDelete = null">
            <div slot="modal-title">
                <h3>Confirm</h3>
            </div>
            <div slot="content">
                <div class="form p-b-0-label" style="margin: 20px">
                    <div>Are you sure you want to delete</div>
                    <div style="font-weight: bold">{{userToDelete.email}}</div>
                </div>
            </div>
            <div slot="modal-footer">
                <div class="footer-btn">
                    <el-button type="danger" size="small" @click="onDeleteUser()">Delete</el-button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

    import CommonUtils from "../common/services/CommonUtils";
    import UsersService from '@/common/services/users.service'
    import {mapMutations, mapState} from "vuex";
    import mutations from "@/store/mutation_types";
    import {LoaderIcon} from 'vue-feather-icons'
    import Modal from "@/common/components/Modal";
    import BusService from '@/common/services/bus.service'

    export default {
        name: 'Dashboard',
        components: {VueLoader: LoaderIcon, Modal},
        data() {
            return {
                search: '',
                all_users: 0,
                companies: 0,
                users_length: 0,
                parking_zones: 0,
                bus_lines: 0,
                travel_offers: 0,
                loading: false,
                userToDelete: null
            }
        },
        computed: {
            ...mapState({
                users: state => state.allUsers,
                travel_offers_length: state => state.travel_offers.length,
                all_buses: state => state.buses,
                user: state => state.user,

            }),
        },
        methods: {
            ...mapMutations(['SET_USERS', 'SET_USER_EMAIL', 'SET_BUSES']),
            onDeleteUser() {
                this.loading = true
                UsersService.deleteUser(this.userToDelete).then(() => {
                    this.users_length = this.users_length - 1;
                    this.all_users = this.all_users - 1;
                    this[mutations.SET_USERS](this.users.filter(el => el.id !== this.userToDelete.id))
                    this.userToDelete = null;
                    this.$notify.success({
                        title: `Deleted`,
                        message: "Successfully deleted"
                    });
                }).catch(() => {
                    this.$notify.error({
                        title: `Error`,
                        message: "Failed to delete"
                    });
                }).finally(() => this.loading = false)
            }
        },
        beforeMount() {
            this.loading = true;
            let user = CommonUtils.getCookie('user_email');
            this[mutations.SET_USER_EMAIL](user);
            UsersService.getAllUsers(user).then(res => {
                this[mutations.SET_USERS](res.data);
                this.all_users = res.data.length;
                this.companies = res.data.filter(el => el.email.includes('@notaxi.info')).length;
                this.users_length = this.allUsers - this.companies;
                this.parking_zones = 63;
                this.bus_lines = 0;
                this.travel_offers = this.travel_offers_length;
            }).catch(err => {
                this.$notify.error({
                    title: `Failed to get users`,
                    message: err.response.data.message
                });
            }).finally(() => {
                this.loading = false;
            })
            let payload = {
                "email": this.user.user_email,
                "cityName": "TETOVO"
            };
            BusService.getBuses(payload).then(response => {
                this[mutations.SET_BUSES](response.data)
            }).catch(error => {
                console.log(error)
                this.$notify.error({
                    title: `Failed to buses`,
                    message: error.response.data.message
                });
            }).finally(() => this.loading = false)
        }
    }
</script>


<style scoped lang="scss">

    .event-card {
        /*border: 1px solid whitesmoke;*/
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        border-radius: 5px;
        cursor: pointer;
        -webkit-box-shadow: 0 0 5px #c7c1c1;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-family: 'Lato', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

        @media screen and (max-width: 768px) {
            min-height: 80px;
        }
    }


    .eventRequests {
        grid-area: eventContainer;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        text-align: center;
        grid-gap: 20px;
        margin: 20px;

        @media screen and (max-width: 768px) {
            display: grid;
            grid-template-columns: 1fr;
        }
    }


    .HOLD {
        color: #DECF3f;
    }


    .NOT_PROCESSED {
        color: #60BD68;
    }


    .CANCELLED {
        color: #F15854;
    }


    .req {
        grid-area: req;
        /*overflow-x: scroll;*/
    }


    .eventProccesContent {
        grid-area: proc;
    }


    .event-card-header {
        display: flex;
        /*text-align: center;*/
        font-size: 16px;
        height: 30px;
        /*border-bottom: 1px solid #e1e1e1;*/
        /*color: #c1c1c1;*/
        justify-content: space-between;
        align-items: center;
    }

    .eventScheduler {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        bottom: 0;
        grid-area: eventScheduler;
        background-color: white;
        min-height: 52vmin;
        margin: 0 20px;
        margin-bottom: 10px;
        border-radius: 5px;
        max-width: 100%;
        overflow: hidden;
        -webkit-box-shadow: 0 0 5px #c7c1c1
    }


    .screen {
        display: grid;
        grid-template-rows: 40vh auto;
        grid-template-areas: "eventContainer" "eventContainer" "eventScheduler";
        width: 100%;
        height: 100%;
        /*height: 100vh;*/
        /*grid-gap: 10px;*/
        background-color: #f6f6f6;

    }


</style>


